/**
 * @generated SignedSource<<144458f6cb3bd8dd526a967e2de2697d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TeamsTeamSelectQuery$variables = {
  name?: string | null;
};
export type TeamsTeamSelectQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly office365: {
        readonly teams: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type TeamsTeamSelectQuery = {
  response: TeamsTeamSelectQuery$data;
  variables: TeamsTeamSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "name",
      "variableName": "name"
    }
  ],
  "concreteType": "OfficeTeamNode",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamsTeamSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamsTeamSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be1a705c0cc44fb709c3415e5dfe7192",
    "id": null,
    "metadata": {},
    "name": "TeamsTeamSelectQuery",
    "operationKind": "query",
    "text": "query TeamsTeamSelectQuery(\n  $name: String\n) {\n  viewer {\n    integrations {\n      office365 {\n        teams(name: $name) {\n          id\n          name\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0588e4a0e9ddfd199fd1a94dd0ffaee";

export default node;
